import type {ReactElement} from 'react';
import {useEffect, useState} from 'react';
import React from 'react';
import {useAppSelector} from '@/hooks';
import {Modal} from '@Components/modal';
import {MODALS_IDS} from '@Components/modal-container';
import {LazyPanel} from '@Components/lazy-panel';
import {openPanelInModal} from '@Components/modal-container/modal-container-reducer';
import type {PosterEditorLineCapModalProps} from '@Modals/poster-editor-line-cap-modal/poster-editor-line-cap-modal.types';
import {useModalData} from '@Components/modal/hooks/useModalData';

const PANEL_ID = 'poster-editor-line-cap-panel';
export default function PosterEditorLineCapModal(): ReactElement<any> {
  const [height, setHeight] = useState('190px');
  const maxWidth = '800px';
  const panelProperties = useAppSelector((state) => {
    return state.panels.panelPropertiesHashmap[PANEL_ID];
  });
  const sizeData = useAppSelector((state) => {
    return state.panels.sizeDataHashmap[PANEL_ID];
  });

  const modalData = useModalData(MODALS_IDS.POSTER_EDITOR_LINE_CAP_MODAL);

  useEffect((): void => {
    if (sizeData?.height) {
      setHeight(sizeData.height);
    }
  }, [sizeData]);

  return (
    <Modal
      doesBottomSheetHaveSnapPoints={panelProperties?.hasSnapPoints}
      snapPointsForBottomSheet={panelProperties?.snapPointsForBottomSheet}
      modalId={MODALS_IDS.POSTER_EDITOR_LINE_CAP_MODAL}
      panelId={PANEL_ID}
      modalHeight={height}
      mobileHeight={height}
      isBottomSheetOnMobile
      isBottomSheetNonBlocking
      modalMaxWidth={maxWidth}
      modalWidth="100%"
    >
      <LazyPanel
        panelDirectoryName="poster-editor-line-cap-panel"
        panelProps={{
          panelId: PANEL_ID,
          ...modalData.panelProps,
        }}
      />
    </Modal>
  );
}

export const openPosterEditorLineCapModal = (props: PosterEditorLineCapModalProps): void => {
  window.PMW.redux.store.dispatch(
    openPanelInModal({
      modalId: MODALS_IDS.POSTER_EDITOR_LINE_CAP_MODAL,
      panelProps: {
        panelId: PANEL_ID,
        lineCapStyleOptionType: props.lineCapStyleOptionType,
      },
    })
  );
};
